
	import {
		defineComponent,
		onMounted,
		ref,
		createVNode,
		reactive
	} from 'vue';
	import {
		Modal,
		message
	} from 'ant-design-vue';
	import {
		DeleteOutlined,
		SyncOutlined
	} from '@ant-design/icons-vue';
	import cityData from '@/assets/data/city.json';
	import allocaFunctionalAreas from "./allocaFunctionalAreas.vue";
	import updatePeople from "./updatePeople.vue";
	import worksNum from "./worksNum.vue";
	import taskreviewer from '@/service/taskreviewer'

	export default defineComponent({
		components: {
			allocaFunctionalAreas,
			updatePeople,
			worksNum,
			DeleteOutlined,
			SyncOutlined
		},
		setup(props, context) {
			// 声明
			let activeKey = ref("0") //0普通评审 1仲裁评审
			let taskId = ref();
			let taskName = ref();
			let taskStatus = ref();
			let primaryKeyID = ref();
			let visible = ref(false);
			let conHeight = ref();
			const openUpdatePop = ref();
			const openWorksNumPop = ref();
			let columns = [{
				title: '登陆账号',
				dataIndex: 'loginName',
				key: 'loginName',
				align: 'center',
			}, {
				title: '姓名',
				dataIndex: 'userName',
				key: 'userName',
				align: 'center',
			}, {
				title: '单位',
				dataIndex: 'unit',
				key: 'unit',
				align: 'center',
			}, {
				title: '学段',
				dataIndex: 'studyPhase',
				key: 'studyPhase',
				align: 'center',
			}, {
				title: '学科',
				dataIndex: 'subject',
				key: 'subject',
				align: 'center',
			}, {
				title: '手机号',
				dataIndex: 'tel',
				key: 'tel',
				align: 'center',
			}, {
				title: '职称',
				dataIndex: 'positionTitle',
				key: 'positionTitle',
				align: 'center',
			}, {
				title: '评审作品数量',
				dataIndex: 'reviewCount',
				key: 'reviewCount',
				align: 'center',
			}, {
				title: '所在区',
				dataIndex: 'district',
				key: 'district',
				align: 'center',
				width: 180,
			}, {
				title: '评审状态',
				dataIndex: 'status',
				key: 'status',
				align: 'center',
			}, {
				title: '操作',
				key: 'action',
				align: "center"
			}];
			let tableData = [];
			let tableLoading = ref(false);
			let searchValue = '';
			let ifAllot = ref('');

			// 页面渲染时加载
			onMounted(() => {})
			// 获取当前屏幕高度 并设置 表格高度
			const tableheight = () => {
				let fullHeight = document.documentElement.clientHeight;
				conHeight.value = fullHeight - 112 - 200;
			}
			// 获取评审人员信息
			const queryTable = () => {
				tableLoading.value = true;
				const start = (state.current - 1) * state.pageSize;
				taskreviewer.queryTaskreviewer(sessionStorage.getItem('schoolCode'), taskId.value, searchValue,
					start, state.pageSize, activeKey.value).then(({
					data
				}) => {
					tableLoading.value = false;
					if (data.code !== 0) return;
					data.data.map(item => {
						cityData[0].children[0].children.map(item2 => {
							if (item2.value == item.district) {
								item.districtMap = "上海市/市辖区/" + item2.label
							}
						})
					})
					tableData.value = data.data;
					state.total = data.total;
				})
			}
			// 打开页面
			const open = (e) => {
				ifAllot.value = e.ifAllot
				taskId.value = e.id;
				taskName.value = e.taskName;
				taskStatus.value = e.status;
				visible.value = true;
				tableheight();
				queryTable();
			}
			const state = reactive({
				current: 1,
				total: 0,
				pageSize: 10
			})
			// 切换tabs
			const changeTabs = (e) => {
				activeKey = ref(e);
				state.total = 0;
				state.pageSize = 10;
				state.current = 1;
				queryTable();
			}

			// 选择一页展示多少条数据
			const onShowSizeChange = (current, pageSize) => {
				state.pageSize = pageSize;
				state.current = current;
				queryTable();
			};
			// 切换分页
			const changePagination = (page, pageSize) => {
				state.pageSize = pageSize;
				state.current = page;
				queryTable();
			};
			// 刷新页面
			const refresh = () => {
				queryTable();
			}
			// 筛选
			const search = (e) => {
				searchValue = e.searchValue;
				queryTable();
			}
			// 删除评审人员
			const delDetails = e => {
				Modal.confirm({
					title: '确认要删除?',
					content: createVNode('div', {
						style: 'color:red;',
					}, ''),
					cancelText: '取消',
					okText: '确认',
					onOk() {
						taskreviewer.delTaskreviewer(e.id).then(({
							data
						}) => {
							if (data.code == '0') {
								queryTable();
								message.success('删除成功');
							} else {
								message.error(data.msg);
							}
						})
					},
					onCancel() {
						console.log('Cancel');
					},
					class: 'test',
				});

			}
			// 更换评审人员
			const updateDetails = (e) => {
				primaryKeyID.value = e.id;
				openUpdatePop.value.open(e, taskId.value, taskName.value, primaryKeyID.value);
			}
			//关闭
			const cancelPop = () => {
				visible.value = false;
				context.emit("refresh", "ok");
			}

			// 打开 老师具体分配的参赛者作品
			const worksNumPop = (e) => {
				openWorksNumPop.value.open(e)
			}

			return {
				activeKey,
				tableData,
				columns,
				open,
				visible,
				state,
				changeTabs,
				search,
				refresh,
				onShowSizeChange,
				changePagination,
				conHeight,
				tableheight,
				tableLoading,
				taskId,
				taskName,
				taskStatus,
				queryTable,
				searchValue,
				delDetails,
				updateDetails,
				openUpdatePop,
				cancelPop,
				ifAllot,
				worksNumPop,
				openWorksNumPop,
				cityData
			};
		},

	});
